import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { AvatarItem } from '@atlaskit/avatar';
import React from 'react';
import styled from 'styled-components';
import { SizeableAvatar } from './SizeableAvatar';
import { getAvatarUrl } from './utils';
var AvatarItemComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none !important;\n  padding: 0 !important;\n  width: auto;\n  overflow: hidden;\n  /* IE 11 needs this prop explicitly to flex items */\n  flex: 1 1 auto;\n  min-width: 100px;\n\n  & > span {\n    box-sizing: border-box;\n  }\n\n  &:hover {\n    width: auto;\n    padding: 0;\n    border: none;\n  }\n"])));
export var SingleValue = function SingleValue(props) {
  var _props$data = props.data,
      label = _props$data.label,
      data = _props$data.data,
      _props$selectProps = props.selectProps,
      appearance = _props$selectProps.appearance,
      isFocused = _props$selectProps.isFocused;
  return !isFocused ? /*#__PURE__*/React.createElement(AvatarItem, {
    backgroundColor: "transparent",
    avatar: /*#__PURE__*/React.createElement(SizeableAvatar, {
      src: getAvatarUrl(data),
      appearance: appearance,
      name: label
    }),
    primaryText: label
  }, function (_ref) {
    var ref = _ref.ref,
        props = _objectWithoutProperties(_ref, ["ref"]);

    return /*#__PURE__*/React.createElement(AvatarItemComponent, props);
  }) : null;
};